/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import Input from '../../components/formComponents/input';
import Textarea from '../../components/formComponents/textarea';
import ImageUploader from '../../services/upload/imageUploader';


/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import APIGet from '../../services/apiCall/get';


class AddProduct extends Component {
  constructor(props){
    super(props);
    this.state = {
        departmentOptions: [],
        categories: {},
        categoryOptions: [],
        subcategories: {},
        subcategoryOptions: [],
        brandOptions: [],
        name: "",
        department: 1,
        category: 1,
        subcategory: 1,
        brand: null,
        buttonText: "",
        images: ["", "", ""],
        variantData: [{name: "", data: [{choice: "", choiceMRP: "", sellingPrice: ""},{choice: "", choiceMRP: "", sellingPrice: ""}]}],
        overview: {details: "", instructions: "", others: ""},
        description: {highlights: "", speacifications: "", others: ""},
        return: {policy: "", others: ""},
        error: ""
    }
  }

  componentDidMount() {
    this.getDepartments();
    this.getBrands();
  }

  getDepartments(){
    let url = devconfig.vendor+'auth/profile';
    APIGet(url).then(function(response){
      if(response.status === "ok"){
        var catData = response.data.category_data;
        var tempArray = [];
        for (var j = 0; j <= catData.length - 1; j++) {
          var item = catData[j]
          tempArray.push({value: item.id, label: item.department});
        }
        this.setState({departmentOptions: tempArray, departmentData: response.data.category_data});
      }
      else{
        this.setState({error: response.message});
      }
    }.bind(this));
  }

  setDepartment(val){
    this.setState({department: val.value});
    let temp = this.state.departmentData;	
    var tempArray = [];
      temp.forEach(async department =>{
        if(department.id == val.value){
            department.category.forEach(item=>{
              tempArray.push({value: item.id, label: item.category});
            })
            await this.setState({categoryOptions: tempArray, categoryData: department.category});
          }
      });
  }

  async setCategory(val){
    this.setState({category: val.value});
    let temp = this.state.categoryData;
    let tempArray = [];
      temp.forEach(category =>{
        if(category.id == val.value){
          category.sub_category.forEach(item=>{
            tempArray.push({value: item.id, label: item.sub_category});
          })
        }
      });
    await this.setState({ subcategoryOptions: tempArray});
  }

  getBrands(){
    let url = devconfig.vendor + 'brand/list';
    APIGet(url).then(function(response){
      if(response.status === "ok" && response.data){
        let temp = [{label: "Others", value: null}];
        response.data.forEach(product=>{
          temp.push({value: product.id, label: product.name})
        });
        this.setState({brandOptions: temp});
      }
      else{
        this.setState({error: response.message});
      }
    }.bind(this));
  }

  // setOptions(data){
  //   let departments = [];
  //   let categories = {};
  //   let subcategories = {};
  //   data.forEach(dep=>{
  //     departments.push({value: dep.id, label: dep.name});
  //     let temp = [];
  //     dep.category.map(cat=>{
  //       temp.push({value: cat.id, label: cat.name});
  //       let temp1 = [];
  //       cat.subcategory.map(sub=>{
  //         temp1.push({value: sub.id, label: sub.name});
  //       });
  //       subcategories[cat.id] = temp1;
  //     });
  //     categories[dep.id] = temp;
  //   });
  //   this.setState({departmentOptions: departments, categories: categories, subcategories: subcategories});
  // }

  setVariantName(name, id){
    let temp = this.state.variantData;
    temp[id].name = name;
    this.setState({variantData: temp});
  }

  setData(type, val, id, i){
    let temp = this.state.variantData;
    temp[id].data[i][type] = val;
    this.setState({variantData: temp});
  }

  overview(type, val){
    let temp = this.state.overview;
    temp[type] = val;
    this.setState({overview: temp});
  }

  descriptionChange(type, val){
    let temp = this.state.description;
    temp[type] = val;
    this.setState({description: temp});
  }

  returnPolicy(type, val){
    let temp = this.state.return;
    temp[type] = val;
    this.setState({return: temp});
  }

  addOptions(){
    let temp = this.state.variantData;
    temp.push({name: "", data: [{choice: "", choiceMRP: "", sellingPrice: ""}, {choice: "", choiceMRP: "", sellingPrice: ""}]});
    this.setState({variantData: temp});
  }

  addVariant(id){
    let temp = this.state.variantData;
    temp[id].data.push({choice: "", choiceMRP: "", sellingPrice: ""});
    this.setState({variantData: temp});
  }

  async deleteOption(id){
    let temp = this.state.variantData;
    if(temp.length===1 && id==0){
      temp = [{name: "", data: [{choice: "", choiceMRP: "", sellingPrice: ""}]}];
    }
    else{
      temp.splice(id, 1);
    }
    await this.setState({variantData: temp});
  }

  deleteVariant(id, i){
    let temp = this.state.variantData;
    temp[id].data.splice(i, 1);
    this.setState({variantData: temp})
  }

  addProduct(){
    this.setState({updateLoading: true, error: ""});
    let temp = this.state.variantData;
    let variants = [];
    let instructions = [];
    if(this.state.overview.instructions.length){
      instructions = this.state.overview.instructions.split(". ");
    }
    let highlights = [];
    if(this.state.description.highlights.length){
      highlights = this.state.description.highlights.split(". ");
    }
    let others1 = [];
    if(this.state.overview.others.length){
      others1 = this.state.overview.others.split(". ");
    }
    let speacifications = [];
    if(this.state.description.speacifications.length){
      speacifications = this.state.description.speacifications.split(". ");
    }
    let others2 = [];
    if(this.state.description.others.length){
      others2 = this.state.description.others.split(". ");
    }
    let others3 = "";
    if(this.state.return.others.length){
      others3 = this.state.return.others
    }
    temp.forEach((element, i)=>{
      let variant = {name: "", choices: []};
      if(element.name){
        variant.name = element.name;
        element.data.forEach((option, j)=>{
          let choices = {name: "", choice: "", mrp: "", selling_price: ""}
          if(option.choice.length && option.choiceMRP.length && option.sellingPrice.length){
            choices.name = option.choice;
            choices.choice = option.choice;
            choices.mrp = option.choiceMRP;
            choices.selling_price = option.sellingPrice;
            variant.choices.push(choices);
          }
          else if(option.choice.length || option.choiceMRP.length || option.sellingPrice.length){
            this.setState({error: "Fill in all the choices"});
          }
        })
        variants.push(variant);
      }
    });
    let imageArray = this.state.images;
    let images = [];
    imageArray.forEach((image, i)=>{
      if(image.length){
        images[i] = image;
      }
    })
    if(!this.state.error.length){
      let url = devconfig.vendor+ 'product/create';
      let data = JSON.stringify({ 
        "name" : this.state.name,
        "department_id" : this.state.department,
        "category_id" : this.state.category,
        "subcategory_id" : this.state.subcategory,
        "brand_id" : this.state.brand.value,
        "brand" : this.state.brand.label,
        "button_text" : this.state.buttonText,
        "images" :  images,
        "overview" : this.state.overview.details,
        "instructions" : instructions,
        "highlights" : highlights,
        "specifications" : speacifications,
        "return_policy" : this.state.return.policy,
        "other_things_1" : others1,
        "other_things_2" : others2,
        "other_things_3" : others3,
        "variants": variants
      });
      APIPost(url, data).then(function(response){
        if(response.status === "ok"){
          this.props.success();
          this.setState({updateLoading: false})
        }
        else{
          this.setState({error: response.message, updateLoading: false});
        }
      }.bind(this))
    }
    else{
      this.setState({updateLoading: false});
    }
  }

  render() {

    return (
      <div>
         <div className="e-main-content e-vendor-table e-manage-add-products">
            <div className="e-page-head w-100">
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                        <h2 className="">Add Product</h2>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 pr-4 py-3">
                    {
                      this.state.name && this.state.department && this.state.category && this.state.subcategory && this.state.brand && this.state.variantData[0].name && this.state.variantData[0].data[0].choice && this.state.variantData[0].data[0].choiceMRP && this.state.variantData[0].data[0].sellingPrice && !this.state.updateLoading?
                      <button className="e-s-btn e-new-ofer mt-n3" onClick={()=>this.addProduct()}>Add New Product</button>
                      :
                      <button className="e-s-btn e-new-ofer mt-n3  e-inactive" disabled={true}>Add New Product</button>
                    }
                    </div>
                </div>
            </div>
            
            <div className="row">
              <div className="col-lg-12">
                <div className="e-vendor-category-list e-edit-ad">
                    <h2>Product / Service Brief</h2>
                    <div className="row pt-4">
                        <div className="col-lg-9">
                            <label>Product / Service Name</label>
                            <Input id="product-name" value={this.state.name} type="text" className="e-add-career" valueChange={(val)=>this.setState({name: val})} placeholder="Max 60 characters"/>
                        </div>
                    </div>
                    <div className="row">
                       <div className="col-lg-3">
                          <label>Department</label>
                          <SelectBox options={this.state.departmentOptions}  
                          selectchange={async (val)=>{
                            this.setDepartment(val);
                          }} placeholder="Select department"/>
                        </div>
                        <div className="col-lg-3">
                          <label>Category</label>
                          <SelectBox options={this.state.categoryOptions} 
                          selectchange={async (val)=>{
                            this.setCategory(val);
                          }} placeholder="Select category"/>
                        </div>
                        <div className="col-lg-3">
                          <label>Subcategory</label>
                          <SelectBox options={this.state.subcategoryOptions} selectchange={(val)=>this.setState({subcategory: val.value})} placeholder="Select subcategory"/>
                        </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-3">
                        <label>Brand</label>
                        <SelectBox  selectchange={(val)=>this.setState({brand: val})} options={this.state.brandOptions} placeholder="Select Brand Name"/>
                      </div>
                      <div className="col-lg-3">
                        <label>Call to action button text</label>
                        <Input id="action-btn" value={this.state.name} type="text" className="e-add-career" valueChange={(val)=>this.setState({buttonText: val})} placeholder="Eg: Avail Now (Max 15 characters)"/>
                      </div>
                    </div>
                    <div className="row pb-5">
                      <div className="col-lg-12">
                        <label className="pt-3">Product / Service Images</label>
                        <div className="row pt-2">
                          {
                            this.state.images.map((image, i)=>(
                              <div className="col-lg-2 py-2">
                                 {
                                   image.length?
                                   <div className="e-ad-banner-upload-preview">
                                  <span className="e-close-icon" onClick={() => {
                                    var tempArry = this.state.images;
                                    tempArry[i] = "";
                                    this.setState({images: tempArry});
                                  }}></span>
                                      <img className src={image}/>
                                </div>
                              : 
                                <span className="e-upload-btn e-banner-upload-btn" onClick={()=>{ $(`#fileUpload${i}`).click()}}>Upload an Image<br/>of 300x300px</span>
                                 }
                                 <ImageUploader
                                  className="pt-4 pb-3 e-upload-banner"
                                  accept={"image/png, image/jpg"}
                                  id={`fileUpload${i}`}
                                  index={0}
                                  tempKey="products/files"
                                  uploadStatus={()=>{}}
                                  uploadSucess={(url)=>{
                                    var tempArry = this.state.images;
                                    tempArry[i] = url;
                                    this.setState({images: tempArry});
                                  }}
                                />
                              </div>
                            ))
                          }
                          <div className="col-lg-2 py-2">
                            <span className="e-banner-upload-btn e-border-dashed" onClick={()=>{let temp = this.state.images; temp.push(""); this.setState({images: temp})}}><p className="mt-n4 user-select-none">Click here to add another Image</p></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="e-vendor-more-details e-border-top container px-0 pb-3"></div>
                    <div className="row pt-2">
                      <div className="col-lg-6">
                        <h2>Options & Varients</h2>
                      </div>
                      <div className="col-lg-6 text-lg-right text-md-right">
                        <span className="e-link " onClick={()=>this.addOptions()}>+ Add New Option / Varient</span>
                        </div>
                      {
                        this.state.variantData.map((variant, id)=>(
                          <div className="col-lg-12 py-3">
                            <div className="e-column border-0">
                              <div className="row py-2">
                                <div className="col-sm-10 col-lg-4 order-1 order-sm-0">
                                  <label>Name</label>
                                  <div className="e-input-wrap mb-2">
                                    <input id={`variant-${id}-name`} value={variant.name} type="text" className="e-add-career" onChange={(e)=>this.setVariantName(e.target.value, id)} placeholder="Eg: Color, Size, Storage etc (Max 15 characters)"/>
                                  </div>
                                </div>
                                <div className="col-sm-2 col-lg-8 order-0 order-sm-1">
                                  <span className="e-delete-icon e-delete-icon-large float-right" onClick={()=>this.deleteOption(id)}></span>
                                </div>
                              </div>
                                {
                                  variant.data.map((data, i)=>(
                                    
                                  <div className="row py-3 py-lg-0">
                                    <div className="col-lg-4 col-sm-10 order-1 order-sm-0">
                                      <label>Choice</label>
                                      <div className="e-input-wrap mb-2">
                                        <input id={`variant-${id}-choice-${i}`} value={data.choice} type="text" className="e-add-career" onChange={(e)=>this.setData("choice", e.target.value, id, i)} placeholder="Eg: Red, XL, 128 GB etc (Max 10 characters)"/>
                                      </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6 order-2">
                                      <label>Choice MRP</label>
                                      <div className="e-input-wrap mb-2">
                                        <input id={`variant-${id}-MRP-${i}`} value={data.choiceMRP} type="number" className="e-add-career" onChange={(e)=>this.setData("choiceMRP", e.target.value, id, i)} placeholder="In INR"/>
                                      </div>
                                    </div>
                                    <div className="col-lg-3 col-sm-6 order-2">
                                      <label>Selling Price</label>
                                      <div className="e-input-wrap mb-2">
                                        <input id={`variant-${id}-SP-${i}`} value={data.sellingPrice} type="number" className="e-add-career" onChange={(e)=>this.setData("sellingPrice", e.target.value, id, i)} placeholder="In INR"/>
                                      </div>
                                    </div>
                                    {
                                      i?
                                      <div className="col-sm-2 pt-4 order-0 order-sm-1 order-lg-2">
                                        <span className="e-delete-icon float-right mt-3" onClick={()=>this.deleteVariant(id, i)}></span>
                                      </div>
                                      :
                                      null
                                    }
                                    </div>
                                  ))
                                }
                                <div className="row">
                                <div className="col-lg-10 py-3">
                                  <div className="container px-0 text-center e-border-dashed py-3" onClick={()=>this.addVariant(id)}>Add another choice</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))      
                      }
                      </div>
                    <div className="row pt-5">
                      <div className="col-lg-12 pb-3">
                        <h2>Overview Details</h2>
                      </div>
                      <div className="col-lg-6">
                        <label>Overview</label>
                        <Textarea id="overview" value={this.state.overview.details} type="text" className="e-add-career" valueChange={(val)=>this.overview("details", val)} placeholder="(Max 100 characters)"/>
                      </div>
                      <div className="col-lg-6">
                        <label>Instructions (If any)</label>
                        <Textarea id="overview-instructions" value={this.state.overview.instructions} type="text" className="e-add-career" valueChange={(val)=>this.overview("instructions", val)} placeholder="(Max 100 characters)"/>
                      </div>
                      <div className="col-lg-6">
                        <label>Other Things (If any)</label>
                        <Textarea id="overview-other" value={this.state.overview.others} type="text" className="e-add-career" valueChange={(val)=>this.overview("others", val)} placeholder="(Max 100 characters)"/>
                      </div>
                    </div>

                    <div className="row pt-4">
                      <div className="col-lg-12 pb-3">
                        <h2>Description Details</h2>
                      </div>
                      <div className="col-lg-6">
                        <label>Highlights</label>
                        <Textarea id="description" value={this.state.description.highlights} type="text" className="e-add-career" valueChange={(val)=>this.descriptionChange("highlights", val)} placeholder="(Max 100 characters)"/>
                      </div>
                      <div className="col-lg-6">
                        <label>Specifications (If any)</label>
                        <Textarea id="description-speacifications" value={this.state.description.speacifications} type="text" className="e-add-career" valueChange={(val)=>this.descriptionChange("speacifications", val)} placeholder="(Max 100 characters)"/>
                      </div>
                      <div className="col-lg-6">
                        <label>Other Things (If any)</label>
                        <Textarea id="description-other" value={this.state.description.others} type="text" className="e-add-career" valueChange={(val)=>this.descriptionChange("others", val)} placeholder="(Max 100 characters)"/>
                      </div>
                    </div>

                    <div className="row pt-4">
                      <div className="col-lg-12 pb-3">
                        <h2>Return Policy Details</h2>
                      </div>
                      <div className="col-lg-6">
                        <label>Return Policy</label>
                        <Textarea id="return" value={this.state.return.policy} type="text" className="e-add-career" valueChange={(val)=>this.returnPolicy("policy", val)} placeholder="(Max 100 characters)"/>
                      </div>
                      <div className="col-lg-6">
                        <label>Other Things (If any)</label>
                        <Textarea id="return-others" value={this.state.return.others} type="text" className="e-add-career" valueChange={(val)=>this.returnPolicy("others", val)} placeholder="(Max 100 characters)"/>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div className="row pt-4 pb-5">
                <div className="col-lg-12 pb-3">
                    {
                      this.state.name && this.state.department && this.state.category && this.state.subcategory && this.state.brand && this.state.variantData[0].name && this.state.variantData[0].data[0].choice && this.state.variantData[0].data[0].choiceMRP && this.state.variantData[0].data[0].sellingPrice && !this.state.updateLoading?
                      <button className="e-s-btn e-new-ofer float-left" onClick={()=>this.addProduct()}>Add New Product</button>
                      :
                      <button className="e-s-btn e-new-ofer float-left  e-inactive" disabled={true}>Add New Product</button>
                    }
                    <button className="e-s-btn e-btn-grey px-5 float-left ml-3" onClick={()=>this.props.cancel()}>Cancel</button>
                </div>
            </div>
          </div>
      </div>

    );
  }
}

export default AddProduct;
